export const getQuestionFieldName = (
  answerTypeUUID: string,
  questionUUID: string,
  groupUUID = ""
) => `${answerTypeUUID},${questionUUID},${groupUUID}`;
